module.exports = __webpack_public_path__ + "static/media/Buscar Clientes.ab4c5c82.svg";